import DocumentEditForm from "./document-edit-form";

const DocumentForms = {
  Edit: DocumentEditForm,
};

export default DocumentForms;
